import React from 'react';
import { Transition, animated, config } from 'react-spring/renderprops';

interface IExpandProps {
    active: boolean;
    children?: JSX.Element;
}

export const Expand: React.FC<IExpandProps> = React.memo(({ active, children }: IExpandProps): JSX.Element => {
    const baseStyles = {
        overflow: 'hidden'
    };

    return (
        <Transition
            config={active ? config.slow : config.gentle}
            items={active}
            from={{ height: 0 }}
            enter={{ height: 'auto' }}
            leave={{ height: 0 }}>
            {(item) => styles => (
                item && <animated.div style={{...baseStyles, ...styles }}>
                    {children}
                </animated.div>
            )}
        </Transition>
    );
});
